/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterWSmall = createReactComponent("outline", "letter-w-small", "IconLetterWSmall", [["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-0" }]]);

export { IconLetterWSmall as default };
//# sourceMappingURL=IconLetterWSmall.mjs.map
